"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Linkedin, Instagram, Youtube } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded-sm" />
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded-sm" />
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded-sm" />
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded-sm" />
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded-sm" />
      </div>;
  }
  const limitedMenuItems = menuItems.slice(0, 5);
  return <nav className="flex flex-wrap gap-6 justify-center md:justify-start">
      {limitedMenuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-sm text-muted-foreground hover:text-foreground hover:underline transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Youtube,
    href: "https://youtube.com",
    label: "YouTube"
  }];
  return <footer ref={ref} className="text-foreground-dark py-12 px-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] opacity-100 translate-y-0 !bg-[hsl(0,0%,100%)] md:px-12">
      <div className="max-w-7xl mx-auto !bg-[hsl(0,0%,100%)]">
        <div className="grid grid-cols-1 gap-8 items-center !text-[hsl(0,0%,0%)] !bg-[hsl(0,0%,100%)] md:grid-cols-3">
          <div className="flex justify-center md:justify-start">
            <MenuProvider menu_id="4">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="flex justify-center">
            <Link to="/" className="inline-block">
              <img src="https://rational-stag.10web.cloud/wp-content/uploads/2026/01/logo-1.png" alt="Salem Ballama Auditing" className="!h-[100px] !w-[350px]" />
            </Link>
          </div>

          <div className="flex gap-4 justify-center md:justify-end">
            {socialLinks.map((social, index) => {
            const Icon = social.icon;
            return <Link key={index} to={social.href} newTab aria-label={social.label} className="text-muted-foreground hover:text-foreground hover:opacity-100 opacity-70 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]">
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-border/20 text-center">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Salem Ballama Auditing. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}